class SinkConfigurator extends HTMLElement {
  constructor() {
    super();

    this.holeCheckboxEls = [];
    this.drainRadioEls = [];
    this.checkbox = this.querySelector('input[type="checkbox"][name="sink-configurator-switch"]');
    this.optionsEl = this.querySelector('.product__sink-configurator__options');
    if (!this.checkbox || !this.optionsEl) return;

    this.holesLabelsHidden = this.querySelector('.sink-configurator__holes-labels');
    this.holesProductionHidden = this.querySelector('.sink-configurator__holes-production');
    this.drainLabelHidden = this.querySelector('.sink-configurator__drain-label');
    this.drainProductionHidden = this.querySelector('.sink-configurator__drain-production');
    this.propertyHiddenInputs = this.querySelectorAll('.sink-configurator__property');

    this.onChangeHandler = this.onChange.bind(this);
    this.checkbox.addEventListener('change', this.onChangeHandler);

    this.onHoleChangeHandler = this.onHolesChange.bind(this);
    this.querySelectorAll('.sink-configurator__hole-checkbox').forEach((cb) => {
      cb.addEventListener('change', this.onHoleChangeHandler);
      this.holeCheckboxEls.push(cb);
    });

    this.onDrainChangeHandler = this.onDrainChange.bind(this);
    this.querySelectorAll('.sink-configurator__drain-radio').forEach((radio) => {
      radio.addEventListener('change', this.onDrainChangeHandler);
      this.drainRadioEls.push(radio);
    });

    this.syncConfiguratorState();
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this.onChangeHandler);
    }
    this.holeCheckboxEls.forEach((cb) => {
      cb.removeEventListener('change', this.onHoleChangeHandler);
    });
    this.drainRadioEls.forEach((radio) => {
      radio.removeEventListener('change', this.onDrainChangeHandler);
    });
  }

  onChange() {
    this.syncConfiguratorState();
  }

  onHolesChange() {
    if (!this.checkbox.checked) return;
    this.syncHolesProperty();
  }

  onDrainChange() {
    if (!this.checkbox.checked) return;
    this.syncDrainProperty();
  }

  syncConfiguratorState() {
    if (this.checkbox.checked) {
      this.optionsEl.removeAttribute('hidden');
      this.setPropertyInputsEnabled(true);
      this.syncHolesProperty();
      this.syncDrainProperty();
      return;
    }

    this.optionsEl.setAttribute('hidden', '');
    this.resetConfiguratorSelections();
    this.clearPropertyInputs();
    this.setPropertyInputsEnabled(false);
  }

  resetConfiguratorSelections() {
    this.holeCheckboxEls.forEach((el) => {
      el.checked = false;
    });
    this.drainRadioEls.forEach((el) => {
      el.checked = false;
    });
  }

  clearPropertyInputs() {
    this.propertyHiddenInputs.forEach((input) => {
      input.value = '';
    });
  }

  setPropertyInputsEnabled(enabled) {
    this.propertyHiddenInputs.forEach((input) => {
      input.disabled = !enabled;
    });
  }

  syncHolesProperty() {
    const labels = [];
    const productions = [];
    this.holeCheckboxEls.forEach((el) => {
      if (el.checked) {
        labels.push(el.dataset.label || '');
        productions.push(el.dataset.production || el.value || '');
      }
    });
    if (this.holesLabelsHidden) {
      this.holesLabelsHidden.value = labels.join(', ');
    }
    if (this.holesProductionHidden) {
      this.holesProductionHidden.value = productions.join(', ');
    }
  }

  syncDrainProperty() {
    const checked = this.querySelector('.sink-configurator__drain-radio:checked');
    if (!this.drainLabelHidden || !this.drainProductionHidden) return;
    if (checked) {
      this.drainLabelHidden.value = checked.dataset.label || '';
      this.drainProductionHidden.value = checked.dataset.production || '';
    } else {
      this.drainLabelHidden.value = '';
      this.drainProductionHidden.value = '';
    }
  }
}

if (!customElements.get('sink-configurator')) {
  customElements.define('sink-configurator', SinkConfigurator);
}
